import React from 'react';

import { DataRow, DataRowProps } from './DataRow';

type StandingOrderSnippetProps = DataRowProps;

const StandingOrderSnippet = (props: StandingOrderSnippetProps) => {
  return (
    <DataRow
      {...props}
      configuration={props.configuration.filter((c) => c.name !== 'statusDisplayName')}
      disabled={Object.keys(props.data)}
    />
  );
};

export default StandingOrderSnippet;
